import { Button } from "antd";
import React from "react";

export const MyBtn = ({ icon, text, type = "primary", onClick }) => {
  return (
    <Button icon={icon} type={type} onClick={onClick}>
      {text}
    </Button>
  );
};
